import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DateStyles } from '../../constants/CentricConstants';
import { statusColours } from '../../constants/ColourConstants';

import DatePicker from 'material-ui/DatePicker';
import { FormattedDate } from 'react-intl';
import IconButton from 'material-ui/IconButton';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import TextField from 'material-ui/TextField';

import SortAlphaIcon from 'material-ui/svg-icons/av/sort-by-alpha';

const sortMethods = {
    default: function(a, b) { return a.id - b.id; },
    fullName: function(a, b) { return a.fullName.localeCompare(b.fullName); },
    moduleName: function(a, b) { return (a.moduleName.localeCompare(b.moduleName)); }
};

class ReportModuleEnrolmentProgress extends Component {
    constructor(){
        super(...arguments);

        this.state = {
            sortName: 'default',
            sort: sortMethods.default,
            statuses: ['waiting', 'enrolled', 'completed'],
            filters: {
                name: '',
                organisation: '',
                moduleName: '',
                enrolledFrom: '',
                enrolledFromTime: 0,
                enrolledTo: '',
                enrolledToTime: 0,
                status: '',
                scoreMin: '',
                scoreMax: '',
                completedFrom: '',
                completedFromTime: '',
                completedTo: '',
                completedToTime: '',
            }
        };
    }

    componentDidMount() {
        this.setSort = this.setSort.bind(this);
        this.setTextFilter = this.setTextFilter.bind(this);
        this.setStatusFilter = this.setStatusFilter.bind(this);
        this.setFilter = this.setFilter.bind(this);
        this.filterData = this.filterData.bind(this);
    }

    render() {
        const style = {
            textFilter: {
                width: '100%'
            },
            dateFilter: {
                width: '100%'
            },
            dropdownFilter: {
                width: '100%'
            }
        };
        
        const data = this.props.data
            .filter(this.filterData)
            .sort(this.state.sort);

        const tableHeaderProps = {
            enableSelectAll:   this.props.display.enableSelectAll,
            displaySelectAll:  this.props.display.enableSelectAll,
            adjustForCheckbox: this.props.display.enableSelectAll
        };
        let tableProps = {
            height:             this.props.display.height,
            fixedHeader:        this.props.display.fixedHeader,
            fixedFooter:        this.props.display.fixedFooter,
            displayRowCheckbox: !!this.props.showCheckboxes,
            selectable:         this.props.display.selectable,
            multiSelectable:    this.props.display.multiSelectable,
        };
        const tableBodyProps = {
            deselectOnClickaway: this.props.display.deselectOnClickaway,
            displayRowCheckbox:  this.props.display.showCheckboxes,
            showRowHover:        this.props.display.showRowHover,
            stripedRows:         this.props.display.stripedRows,
        };

        if (!!this.props.onRowSelect) {
            tableProps.onRowSelection = this.props.onRowSelect;
        }
        const textFilterProps = {
            hintText: 'Filter',
            onChange: this.setTextFilter,
            style:    style.textFilter
        };

        const dropdownFilterProps = {
            hintText: 'Filter',
            onChange: this.setStatusFilter,
            style:    style.dropdownFilter
        };

        let minFilterProps = {
            hintText: 'Minimum',
            onChange: this.setTextFilter,
            style:    style.textFilter
        };
        if (this.state.filters.scoreMin !== '' && isNaN(Number(this.state.filters.scoreMin))) {
            minFilterProps.errorText = 'Please enter a number';
        }
        let maxFilterProps = {
            hintText: 'Maximum',
            onChange: this.setTextFilter,
            style:    style.textFilter
        };
        if (this.state.filters.scoreMax !== '' && isNaN(Number(this.state.filters.scoreMax))) {
            maxFilterProps.errorText = 'Please enter a number';
        }

        const dateFilterProps = {
            formatDate:     (date) => (date instanceof Date ? date.toLocaleDateString() : null),
            style:          style.dateFilter,
            textFieldStyle: style.dateFilter
        };

        return (
            <Table {...tableProps} >
                <TableHeader {...tableHeaderProps} >
                    <TableRow>
                        <TableHeaderColumn>
                            Name
                            <IconButton onTouchTap={this.setSort('fullName')} >
                                <SortAlphaIcon />
                            </IconButton>
                        </TableHeaderColumn>
                        <TableHeaderColumn>Organisation</TableHeaderColumn>
                        <TableHeaderColumn>Module
                            <IconButton onTouchTap={this.setSort('moduleName')} >
                                <SortAlphaIcon />
                            </IconButton>
                        </TableHeaderColumn>
                        <TableHeaderColumn>Enrolment</TableHeaderColumn>
                        <TableHeaderColumn>Status</TableHeaderColumn>
                        <TableHeaderColumn>Score</TableHeaderColumn>
                        <TableHeaderColumn>Completed</TableHeaderColumn>
                    </TableRow>
                    <TableRow>
                        <TableHeaderColumn>
                            <TextField name="name" value={this.state.filters.name} {...textFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <TextField name="organisation" value={this.state.filters.organisation} {...textFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <TextField name="moduleName" value={this.state.filters.moduleName} {...textFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <DatePicker hintText="From" onChange={(e,v) => this.setFilter('enrolledFrom', v)} {...dateFilterProps} />
                            <DatePicker hintText="To"   onChange={(e,v) => this.setFilter('enrolledTo', v)}   {...dateFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <SelectField name="status" value={this.state.filters.status} {...dropdownFilterProps}>
                                <MenuItem value="" primaryText="No filter" label=" " />
                                {this.state.statuses.map((status, index) => <MenuItem key={index} value={status} primaryText={status} />)}
                            </SelectField>
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <TextField name="scoreMin" value={this.state.filters.scoreMin} {...minFilterProps} /><br />
                            <TextField name="scoreMax" value={this.state.filters.scoreMax} {...maxFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <DatePicker hintText="From" onChange={(e,v) => this.setFilter('completedFrom', v)} {...dateFilterProps} />
                            <DatePicker hintText="To"   onChange={(e,v) => this.setFilter('completedTo', v)}   {...dateFilterProps} />
                        </TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody {...tableBodyProps} >
                    {data.map((row, index) => {
                        const moduleName = row.moduleName;
                        const organisations = this.getList(row.organisations);
                        const orgTitle = row.organisations.replace(/\|/g, "\n");

                        return (
                            <TableRow key={index} selected={row.selected} style={{color: !row.archived ? statusColours.default : statusColours.waiting}}>
                                <TableRowColumn>
                                    {!row.archived
                                        ? row.fullName
                                        : <span title="Archived user">{row.fullName}</span>
                                    }
                                </TableRowColumn>
                                <TableRowColumn title={orgTitle} >{organisations}</TableRowColumn>
                                <TableRowColumn>{moduleName}</TableRowColumn>
                                <TableRowColumn>
                                    {(!!row.dateEnrolled && !isNaN(Date.parse(row.dateEnrolled))) && (
                                        <FormattedDate {...DateStyles.long} value={row.dateEnrolled} />
                                    )}
                                </TableRowColumn>
                                <TableRowColumn>{row.status}</TableRowColumn>
                                <TableRowColumn>{row.score}</TableRowColumn>
                                <TableRowColumn>
                                    {(!!row.dateCompleted && !isNaN(Date.parse(row.dateCompleted))) && (
                                        <FormattedDate {...DateStyles.long} value={row.dateCompleted} />
                                    )}
                                </TableRowColumn>
                            </TableRow>
                        );
                    }, this)}
                </TableBody>

            </Table>
        );
    }

    setSort(sort) {
        const f = () => {
            if (sortMethods.hasOwnProperty(sort) && this.state.sortName !== sort) {
                this.setState({sortName: sort, sort: sortMethods[sort]});
            }
        };

        return f.bind(this);
    }

    setTextFilter(event) {
        this.setFilter(event.target.name, event.target.value.toLocaleLowerCase());
    }

    setStatusFilter(event, i, value) {
        this.setFilter('status', value);
    }

    setFilter(filter, value) {
        if (this.state.filters.hasOwnProperty(filter)) {
            let filters = this.state.filters;
            filters[filter] = value ;
            if (filters.hasOwnProperty(filter + 'Time')) {
                filters[filter + 'Time'] = (value instanceof Date ? value.getTime() : '');
            }
            this.setState({filters: filters});
        }
    }

    filterData(row) {
        let valid = (row !== undefined);
        if (valid && !!this.state.filters.name) {
            valid = (-1 < row.fullName.toLocaleLowerCase().search(this.state.filters.name));
        }

        if (valid && !!this.state.filters.organisation) {
            valid = (-1 < row.organisations.toLocaleLowerCase().search(this.state.filters.organisation));
        }

        if (valid && !!this.state.filters.moduleName) {
            valid = (-1 < row.moduleName.toLocaleLowerCase().search(this.state.filters.moduleName));
        }

        if (valid && !!this.state.filters.status) {
            valid = row.status === this.state.filters.status;
        }

        if (valid && this.state.filters.scoreMin !== '' && !isNaN(Number(this.state.filters.scoreMin))) {
            valid = (this.state.filters.scoreMin <= row.score);
        }

        if (valid && this.state.filters.scoreMax !== '' && !isNaN(Number(this.state.filters.scoreMax))) {
            valid = (row.score <= this.state.filters.scoreMax);
        }

        const enrolled = (new Date(row.dateEnrolled)).setHours(0, 0, 0);
        if (valid && !!this.state.filters.enrolledFrom) {
            valid = (!!enrolled && this.state.filters.enrolledFromTime <= enrolled);
        }
        if (valid && !!this.state.filters.enrolledTo) {
            valid = (!!enrolled && enrolled <= this.state.filters.enrolledToTime );
        }

        const completed = (new Date(row.dateCompleted)).setHours(0, 0, 0);
        if (valid && !!this.state.filters.completedFrom) {
            valid = (!!completed && this.state.filters.completedFromTime <= completed);
        }
        if (valid && !!this.state.filters.completedTo) {
            valid = (!!completed && completed <= this.state.filters.completedToTime );
        }

        return valid;
    }

    getList(line, separator) {
        let list = '';
        const spanProps = {
            style: {
                marginRight: '1em'
            },
            className: 'inline-list'
        };
        if (!!line) {
            list = line.split(separator || '|').map((e, i) => <span key={i} {...spanProps} >{e}</span>);
        }
        return list;
    }

}

ReportModuleEnrolmentProgress.propTypes = {
    display: PropTypes.object,
    onRowSelect: PropTypes.func,
    data: PropTypes.arrayOf(PropTypes.object),
};

ReportModuleEnrolmentProgress.defaultProps = {
    display: {
        fixedHeader: true,
        fixedFooter: true,
        stripedRows: false,
        showRowHover: false,
        showCheckboxes: false,
        selectable: false,
        multiSelectable: false,
        enableSelectAll: false,
        deselectOnClickaway: false,
    },
    data: []
};

export default ReportModuleEnrolmentProgress;
